import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'httpLink'
})
export class HttpLinkPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  // Convert plain text containing URLs into safe HTML with clickable links.
  // 1. Escape any HTML provided by the user to prevent XSS.
  // 2. Linkify http/https URLs found anywhere in the text.

  private escapeHtml(s: string): string {
    return s.replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c] as string));
  }

  transform(value: string): SafeHtml | string {
    if (!value) {
      return '';
    }

    value = value.replaceAll("https://app.mysembra.com", window.location.origin);

    let currentHost: string | null = null;
    try { currentHost = window?.location?.hostname || null; } catch { /* noop */ }

    // Match http/https URLs and avoid swallowing common trailing punctuation.
    const urlRegex = /(https?:\/\/[^\s<>'")]+)([)\].,;!?]*)/gi;

    let result = '';
    let lastIndex = 0;

    value.replace(urlRegex, (match, url: string, trailing: string, offset: number) => {
      result += this.escapeHtml(value.slice(lastIndex, offset));

      // Validate URL
      let u: URL;
      try {
        u = new URL(url);
        if (!/^https?:$/.test(u.protocol)) throw new Error('unsupported');
      } catch {
        // Not a valid URL: render the matched text escaped
        result += this.escapeHtml(match);
        lastIndex = offset + match.length;
        return '';
      }

      const display = this.escapeHtml(url);
      const href = this.escapeHtml(u.toString()); // should be safe

      if (currentHost && u.hostname === currentHost) {
        // Same-host links: clickable, open in same tab
        const html = `<a type="button" style="color:blue;text-decoration:underline">${this.escapeHtml(display)}</a>`;

        result += html;
      } else {
        // External links: open in new tab, safe rel attrs
        result += `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color:blue;text-decoration:underline">${this.escapeHtml(display)}</a>`;
      }

      // Re-append any trailing punctuation (escaped)
      result += this.escapeHtml(trailing || '');

      lastIndex = offset + match.length;
      return '';
    });

    // Append the remainder of the text
    result += this.escapeHtml(value.slice(lastIndex));

    // Bold the sender name (everything before the first ": ")
    result = result.replace(/^([^<:]+:\s)/, '<strong>$1</strong>');

    return this.sanitizer.sanitize(SecurityContext.HTML, result) || '';
  }
}